import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    mes_atelierList : [],
    selectedAtelier:{},
}
const atelierSlice = createSlice({
    name:'atelier',
    initialState,
    reducers:{
        setAtelierList:(state,payload)=>{
            state.mes_atelierList = payload
            console.log("Mon payload ateliers: ",state.mes_atelierList)
        },
        setAtelierProfile:(state,{payload})=>{
            state.selectedAtelier = payload
        },
    }
})

export const { setAtelierList,setAtelierProfile} = atelierSlice.actions
export default atelierSlice.reducer